// pattern: imperative-shell
import { LIGHT_LEVELS } from "../core/location-model";
import type { ApiLocation } from "../shell/api-client";
import { api } from "../shell/api-client";

export async function renderLocationManager(container: HTMLElement): Promise<void> {
	container.innerHTML = '<div class="loading">Loading...</div>';

	try {
		const locations = await api.getLocations();
		renderManager(container, locations);
	} catch (e) {
		container.innerHTML = `<div class="content"><div class="error">${e instanceof Error ? e.message : "unknown error"}</div></div>`;
	}
}

function renderManager(container: HTMLElement, locations: ApiLocation[]): void {
	const lightOptions = LIGHT_LEVELS.map((l) => `<option value="${l}">${l}</option>`).join("");

	container.innerHTML = `
		<div class="content">
			<form id="loc-form" style="margin-bottom: 24px">
				<div class="form-group">
					<label class="form-label" for="loc-name">Location Name</label>
					<input class="form-input" type="text" id="loc-name" name="name"
						placeholder="e.g. Shade Garden" required />
				</div>
				<div class="form-group">
					<label class="form-label" for="loc-light">Light Level</label>
					<select class="form-select" id="loc-light" name="light">
						${lightOptions}
					</select>
				</div>
				<div class="form-group">
					<label class="form-label" for="loc-notes">Notes</label>
					<textarea class="form-textarea" id="loc-notes" name="notes"
						placeholder="Optional details..."></textarea>
				</div>
				<div id="loc-error"></div>
				<button class="btn btn-primary btn-full" type="submit">Add Location</button>
			</form>

			<div id="loc-list">
				${locations.length === 0 ? '<div class="empty"><div class="empty-text">No locations yet. Add your garden areas above.</div></div>' : ""}
				${locations.map((l) => locationCard(l)).join("")}
			</div>
		</div>
	`;

	const form = container.querySelector<HTMLFormElement>("#loc-form")!;
	form.addEventListener("submit", async (e) => {
		e.preventDefault();
		const fd = new FormData(form);
		const data = {
			name: fd.get("name"),
			light: fd.get("light"),
			notes: fd.get("notes") || undefined,
		};

		const errEl = container.querySelector("#loc-error")!;
		try {
			await api.createLocation(data);
			// Re-render the whole thing
			await renderLocationManager(container);
		} catch (err) {
			errEl.innerHTML = `<div class="error">${err instanceof Error ? err.message : "Save failed"}</div>`;
		}
	});

	// Delete buttons
	container.querySelectorAll<HTMLButtonElement>("[data-delete-loc]").forEach((btn) => {
		btn.addEventListener("click", async () => {
			const id = btn.dataset["deleteLoc"]!;
			if (!confirm("Delete this location?")) return;
			try {
				await api.deleteLocation(id);
				await renderLocationManager(container);
			} catch (err) {
				alert(err instanceof Error ? err.message : "Delete failed");
			}
		});
	});
}

function locationCard(loc: ApiLocation): string {
	return `
		<div class="card">
			<div class="card-header">
				<span class="card-title">${esc(loc.name)}</span>
				<span class="stage-pill stage-${loc.light === "shade" ? "dormant" : loc.light === "partial" ? "budding" : "blooming"}">${loc.light}</span>
			</div>
			${loc.notes ? `<div class="observation-notes">${esc(loc.notes)}</div>` : ""}
			<div class="actions">
				<button class="btn btn-danger btn-small" data-delete-loc="${loc.id}">Delete</button>
			</div>
		</div>
	`;
}

function esc(s: string): string {
	const el = document.createElement("span");
	el.textContent = s;
	return el.innerHTML;
}
